import React from 'react'

import CloneForm from './CloneForm'
import ControlledModal from '../../../components/modals/ControlledModal'
import Header from './Header'
import ServiceOrderLoader from './_load/ServiceOrderLoader'

const CloneServiceOrderModal = props => {
  return (
    <ControlledModal width="38rem" {...props} disableClickOutside>
      <ServiceOrderLoader>
        <Header />
        <CloneForm />
      </ServiceOrderLoader>
    </ControlledModal>
  )
}

export default CloneServiceOrderModal
